import get from 'lodash.get';
import * as yup from 'yup';
import { Client } from 'store/clients';
import { validateText, validateObject, validateStringArray } from 'utils/validation';
import { CustomerForm } from './types';

/** Schema for validating the customer form */
export const customerSchema = yup.object().shape({
  name: validateText(),
  restrictedFonts: validateStringArray(),
  salesReportSettings: validateObject()
});

/**
 * Generates the customer form based on the provided client (aka customer).
 * If no client is provided, the fields are set with empty values.
 */
export const getCustomerForm = (client?: Client): CustomerForm => {
  const name = get(client, 'name', '');
  const restrictedFonts = JSON.stringify(get(client, 'configuration.restrictedFonts', []));
  const salesReportSettings = JSON.stringify(get(client, 'configuration.salesReportSettings', {}));

  return {
    name: {
      error: null,
      initialValue: name,
      propertyPath: 'name',
      readOnly: false,
      shouldParse: false,
      value: name
    },
    restrictedFonts: {
      error: null,
      initialValue: restrictedFonts,
      propertyPath: 'configuration.restrictedFonts',
      readOnly: false,
      shouldParse: true,
      value: restrictedFonts
    },
    salesReportSettings: {
      error: null,
      initialValue: salesReportSettings,
      propertyPath: 'configuration.salesReportSettings',
      readOnly: false,
      shouldParse: true,
      value: salesReportSettings
    }
  };
};
